import styled from "styled-components";

type ContainerType = {
    border: string;
}

export const Container = styled.div<ContainerType>`
    display: flex;
    flex-direction: column;
    padding: 50px 16px 16px 16px;
    border: .5px solid ${props => props.border};
    border-radius: 4px;
    width: 532px;
    max-width: 532px;
`;

export const PaddingFilters = styled.div`
    padding-top: 16px;
    display: flex;
    flex: 1;
`;

export const ContentRow = styled.div`
    display: flex;
    flex: 1;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 0;
`;

export const Footer = styled.div`
    margin-top: 16px;
    display: flex;
    flex-direction: row;
`;
